import { styled, Typography } from "@mui/material";

export const GradientTypography = styled(Typography)(() => ({
  display: "inline-block",
  background: `linear-gradient(91deg, #FAFAFA 0.16%, rgba(250, 250, 250, 0.60) 100%)`,
  WebkitBackgroundClip: "text",
  backgroundClip: "text",
  color: "transparent",
}));
